export default "__VITE_ASSET__WV344myk__"